import { insertIf } from '../../../../helpers/common'

export const NAME = 'name'
export const STATUS = 'status'

// type
export const RIGHT_TYPE = 'right_type'
export const RIGHT_TYPE_DIGITAL = 'digital'
export const RIGHT_TYPE_POSTS = 'social_posts'
export const RIGHT_TYPE_ONSITE = 'onsite'
export const RIGHT_TYPE_OTHER = 'none'

// digital allocation
export const DIGITAL_ALLOCATION_TYPE = 'digital_allocation_type'
export const DIGITAL_ALLOCATION_TYPE_BUDGET = 'budget'
export const DIGITAL_ALLOCATION_TYPE_IMPRESSIONS = 'impressions'
export const DIGITAL_ALLOCATION_IMPRESSIONS = 'digital_allocation_impressions'
export const BID_CAP = 'bid_cap'

// allocation and delivery
export const ALLOCATION = 'allocation'
export const ALLOCATION_UNIT = 'allocation_unit'
export const DELIVERED = 'delivered'
// action for the partner
export const ACTION = 'action'
// gender
export const GENDER = 'gender'
export const GENDER_MALE = 'gender_male'
export const GENDER_FEMALE = 'gender_female'
// ages
export const AGE = 'age'
// countries
export const COUNTRIES = 'countries'
// budget
export const BUDGET = 'budget'
// brand keywords
export const BRAND_KEYWORDS = 'keywords'
// request creative
export const REQUEST_CREATIVE_ASSETS = 'creative_assets_required'
export const CREATIVE_ASSETS_DATE = 'creative_assets_date'
export const REQUEST_LOGO = 'logo_required'
export const LOGO_DATE = 'logo_date'
// campaigns
export const CAMPAIGNS = 'campaigns'
// social media post
export const SOCIAL_MEDIA_POST = 'social_media_post'
export const INCLUDE_LINKED_INSTAGRAM_ACCOUNT = 'include_linked_instagram_account'
export const LINKED_INSTAGRAM_ACCOUNT = 'linked_instagram_account'

export const getRightTypeOptions = ({ isDigitalRightTypeAllowed, isOnsiteRightTypeAllowed }) => [
  ...insertIf(isDigitalRightTypeAllowed, {
    value: RIGHT_TYPE_DIGITAL,
    label: 'Digital'
  }),
  {
    value: RIGHT_TYPE_POSTS,
    label: 'Posts'
  },
  ...insertIf(isOnsiteRightTypeAllowed, {
    value: RIGHT_TYPE_ONSITE,
    label: 'Onsite'
  }),
  {
    value: RIGHT_TYPE_OTHER,
    label: 'Other'
  }
]

export const digitalAllocationTypeOptions = [
  {
    value: DIGITAL_ALLOCATION_TYPE_BUDGET,
    label: 'Budget'
  },
  {
    value: DIGITAL_ALLOCATION_TYPE_IMPRESSIONS,
    label: 'Impressions'
  }
]
